// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_a8-0";
export var optionCard = "_a8-1";